export const CLEAR_ACTIONS_STATUSES = "CLEAR_ACTIONS_STATUSES";

export const clearActionsStatuses = actions => ({
    type: CLEAR_ACTIONS_STATUSES,
    actions
})
